module.exports = __webpack_public_path__ + "img/4-Stepp-Live-Chat-Page-MVP.8cf2c596.png";